// Shared constants for account name validation
export const ACCOUNT_NAME_MIN_LENGTH = 2;
export const ACCOUNT_NAME_MAX_LENGTH = 30;

// Username/password sign-in: error code thrown by the credentials authorize() when a
// user exists + the password is correct but username login is not enabled for them
// (users.username_login_allowed = false). Client-safe so both the server gate
// (credentials.ts) and the login form can reference it without crossing the boundary.
// SYNC: SYSTEM_DESCRIPTION.md §1 "Authentication & Authorization".
export const USERNAME_LOGIN_DISABLED_CODE = "USERNAME_LOGIN_DISABLED";

// Allowed characters regex - letters (including international), numbers, spaces, hyphens
export const ALLOWED_CHARACTERS_REGEX = /^[a-zA-Z0-9\u00C0-\u00FF\u0100-\u017F\s\-]*$/;

// Characters to remove/block regex
export const BLOCKED_CHARACTERS_REGEX = /[^a-zA-Z0-9\u00C0-\u00FF\u0100-\u017F\s\-]/g;

// SQL injection and XSS patterns
export const SUSPICIOUS_PATTERNS = [
  /drop\s+table/i,
  /delete\s+from/i,
  /insert\s+into/i,
  /update\s+set/i,
  /select\s+.*from/i,
  /union\s+select/i,
  /script/i,
  /javascript/i,
  /onload/i,
  /onerror/i,
];

// HTML tag removal regex
export const HTML_TAG_REGEX = /<[^>]*>/g;

// SQL injection characters regex
export const SQL_INJECTION_CHARS_REGEX = /['";\\]/g;

// Whitespace normalization regex
export const WHITESPACE_NORMALIZE_REGEX = /\s+/g;

// Client-side validation function
export const isValidInputStringCharacter = (char: string): boolean => {
  return ALLOWED_CHARACTERS_REGEX.test(char);
};

export const GRAPHQL_ENDPOINT =
  process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT || "/api/graphql";
